import 'css-chunk-1JavaScriptSource/components/tool-dialog/style.module.scss';export default {
  "toolDialog": "_toolDialog_odpsn_1",
  "header": "_header_odpsn_18",
  "titleBar": "_titleBar_odpsn_34",
  "closeBtn": "_closeBtn_odpsn_38"
};